import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarWithCircleColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" {...props}>
      <circle
        cx={14}
        cy={14}
        r={12}
        stroke="url(#calendar_with_circle_colored_svg)"
        strokeWidth={2.5}
      />
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeWidth={0.5}
        d="M12.182 10.029V9m4.636 1.029V9m-4.636 3.086h4.636M11.636 18h5.728c.903 0 1.636-.69 1.636-1.543v-4.886c0-.852-.733-1.542-1.636-1.542h-5.728c-.903 0-1.636.69-1.636 1.542v4.886c0 .852.733 1.543 1.636 1.543Z"
      />
      <defs>
        <linearGradient
          id="calendar_with_circle_colored_svg"
          x1={14}
          x2={14}
          y1={2}
          y2={26}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarWithCircleColored);
export default ForwardRef;
